<script>

import { compute_rest_props } from "svelte/internal";

</script>
 
<svg width="100%" height="100%" viewBox="0 0 27 19" fill="none" xmlns="http://www.w3.org/2000/svg" style="">
    <g clip-path="url(#clip0)">
        
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7409 3.29997L25.0109 1.49997L25.7209 0.49997H24.0909L23.6009 0.77997H14.7509L14.4809 1.31997H12.2009L11.9309 0.74997H3.08094L2.59094 0.469971H0.960938L1.67094 1.46997L2.95094 3.26997L3.46094 3.99997H5.05094L5.10094 4.06997L9.58094 10.6L9.64094 10.69V10.74V10.8V10.88V10.95L9.47094 11.51L9.34094 11.92L9.26094 12.15L9.75094 12.84L12.7509 17.08L13.3609 17.95L13.9709 17.08L16.9709 12.85L17.4609 12.15L17.3909 11.91L17.2609 11.51L17.0809 10.95V10.88V10.8V10.74V10.69L17.1409 10.6L21.6209 4.07997V4.00997H23.2009L23.7409 3.29997ZM21.2409 4.08997L21.9909 3.03997H15.0509L14.8309 3.48997H11.8409L11.6209 3.03997H4.69094L5.44094 4.08997H6.77094L7.03094 4.43997V4.49997L10.8809 10.1L11.1009 10.43L10.9909 10.81V10.86L10.7509 11.61L13.2809 15.18L15.8409 11.69L15.6109 10.96L15.4609 10.53L15.7209 10.17L19.5509 4.57997L19.6009 4.51997L19.8509 4.16997H21.2409V4.08997ZM13.3509 9.74997C13.7845 9.75195 14.2089 9.62519 14.5703 9.38576C14.9318 9.14633 15.2141 8.80499 15.3814 8.405C15.5486 8.00501 15.5934 7.56436 15.5101 7.13889C15.4267 6.71341 15.2189 6.32226 14.913 6.01498C14.6072 5.7077 14.217 5.49813 13.7919 5.41281C13.3668 5.3275 12.9259 5.37028 12.5252 5.53574C12.1244 5.70119 11.7818 5.98188 11.5407 6.34224C11.2996 6.7026 11.1709 7.1264 11.1709 7.55997C11.1709 8.13907 11.4003 8.69459 11.8088 9.10501C12.2174 9.51543 12.7718 9.74733 13.3509 9.74997V9.74997ZM23.5309 2.84997H22.3309L22.2309 2.98997L22.1409 3.12997L18.0009 9.12997L17.9409 9.20997L17.8609 9.31997V9.47997V9.57997L18.0909 10.33L18.4809 9.77997L18.5909 9.62997L18.8209 9.29997L22.8409 3.83997L23.0309 3.56997L23.1509 3.39997L23.5309 2.84997ZM8.32094 10.41L8.57094 9.61997V9.53997V9.37997L8.49094 9.26997L8.44094 9.20997L4.28094 3.13997L4.19094 3.00997L4.09094 2.85997H2.89094L3.28094 3.41997L3.40094 3.58997L3.59094 3.85997L7.51094 9.39997L7.84094 9.74997L7.94094 9.88997L8.32094 10.41Z" stroke="white" stroke-miterlimit="10" class="seqpICfA_0"></path>
    </g>
    <defs>
    <clipPath id="clip0">
    <path width="26.68" height="18.86" fill="white" d="M0 0 L26.68 0 L26.68 18.86 L0 18.86 Z" class="seqpICfA_1"></path>
    </clipPath>
    </defs>
    <g clip-path="url(#clip0)">
        
        <path  clip-rule="evenodd" d="M23.7409 3.29997L25.0109 1.49997L25.7209 0.49997H24.0909L23.6009 0.77997H14.7509L14.4809 1.31997H12.2009L11.9309 0.74997H3.08094L2.59094 0.469971H0.960938L1.67094 1.46997L2.95094 3.26997L3.46094 3.99997H5.05094L5.10094 4.06997L9.58094 10.6L9.64094 10.69V10.74V10.8V10.88V10.95L9.47094 11.51L9.34094 11.92L9.26094 12.15L9.75094 12.84L12.7509 17.08L13.3609 17.95L13.9709 17.08L16.9709 12.85L17.4609 12.15L17.3909 11.91L17.2609 11.51L17.0809 10.95V10.88V10.8V10.74V10.69L17.1409 10.6L21.6209 4.07997V4.00997H23.2009L23.7409 3.29997ZM21.2409 4.08997L21.9909 3.03997H15.0509L14.8309 3.48997H11.8409L11.6209 3.03997H4.69094L5.44094 4.08997H6.77094L7.03094 4.43997V4.49997L10.8809 10.1L11.1009 10.43L10.9909 10.81V10.86L10.7509 11.61L13.2809 15.18L15.8409 11.69L15.6109 10.96L15.4609 10.53L15.7209 10.17L19.5509 4.57997L19.6009 4.51997L19.8509 4.16997H21.2409V4.08997ZM13.3509 9.74997C13.7845 9.75195 14.2089 9.62519 14.5703 9.38576C14.9318 9.14633 15.2141 8.80499 15.3814 8.405C15.5486 8.00501 15.5934 7.56436 15.5101 7.13889C15.4267 6.71341 15.2189 6.32226 14.913 6.01498C14.6072 5.7077 14.217 5.49813 13.7919 5.41281C13.3668 5.3275 12.9259 5.37028 12.5252 5.53574C12.1244 5.70119 11.7818 5.98188 11.5407 6.34224C11.2996 6.7026 11.1709 7.1264 11.1709 7.55997C11.1709 8.13907 11.4003 8.69459 11.8088 9.10501C12.2174 9.51543 12.7718 9.74733 13.3509 9.74997V9.74997ZM23.5309 2.84997H22.3309L22.2309 2.98997L22.1409 3.12997L18.0009 9.12997L17.9409 9.20997L17.8609 9.31997V9.47997V9.57997L18.0909 10.33L18.4809 9.77997L18.5909 9.62997L18.8209 9.29997L22.8409 3.83997L23.0309 3.56997L23.1509 3.39997L23.5309 2.84997ZM8.32094 10.41L8.57094 9.61997V9.53997V9.37997L8.49094 9.26997L8.44094 9.20997L4.28094 3.13997L4.19094 3.00997L4.09094 2.85997H2.89094L3.28094 3.41997L3.40094 3.58997L3.59094 3.85997L7.51094 9.39997L7.84094 9.74997L7.94094 9.88997L8.32094 10.41Z" stroke="white" stroke-miterlimit="10" class="seqpICfA_2"></path>
        </g>
        <defs>
        <clipPath id="clip0">
        <path width="26.68" height="18.86" fill="black" d="M0 0 L26.68 0 L26.68 18.86 L0 18.86 Z" class="seqpICfA_2"></path>
        </clipPath>
        </defs>
    <style data-made-with="vivus-instant">
    svg .seqpICfA_0 {
	opacity: 1;
	transition: 2;
	stroke-dasharray: 174 176;
	stroke-dashoffset: 175;
	animation: seqpICfA_erase 1305ms ease-in 0ms forwards;
    padding:20px;
}

svg .seqpICfA_1 {
	opacity: 1;
	transition: 2;
	stroke-dasharray: 92 94;
	stroke-dashoffset: 93;
	animation: seqpICfA_erase 1305ms ease-in 0ms forwards;
    padding:20px;
}

svg:hover .seqpICfA_0 {
	stroke-dasharray: 174 176;
	stroke-dashoffset: 175;
	animation: seqpICfA_draw 1305ms ease-in 0ms forwards;
	opacity: 1;
}

svg:hover .seqpICfA_1 {
	stroke-dasharray: 92 94;
	stroke-dashoffset: 93;
	animation: seqpICfA_draw 694ms ease-in 1305ms forwards;
	opacity: 1;
}

.seqpICfA_2,
.seqpICfA_3 {
	opacity: 0.1;
	transition: 0.5;
}

@keyframes seqpICfA_erase {
	0% {
		stroke-dashoffset: 0;
	}
}

@keyframes seqpICfA_draw {
	100% {
		stroke-dashoffset: 0;
	}
}

@keyframes seqpICfA_fade {
	0% {
		stroke-opacity: 1;
	}
	93.54838709677419% {
		stroke-opacity: 1;
	}
	100% {
		stroke-opacity: 0;
	}
}</style></svg>
    